<script setup lang="ts">
import { type BasicUser } from '@models/basicUser.ts';
import Typography from '@components/Typography.vue';
import ProfilePicture from '@components/ProfilePicture.vue';
import { trans, transchoice } from '@elements/translation';

defineProps<{
  primaryContact: BasicUser,
  partnershipDate: Date | null,
  averageResponseDelay: number,
}>();
</script>

<template>
  <div class="primary-contact-summary">
    <Typography
      variant="body"
      color="gray-darker"
    >
      {{ transchoice('offer.contact.primary_contact.title', { name: primaryContact.firstname }) }}
    </Typography>

    <div class="primary-contact-summary__content">
      <div class="primary-contact-summary__wrapper-img">
        <ProfilePicture
          class="primary-contact-summary__picture"
          :uuid="primaryContact.profile_picture?.uuid"
          :user-firstname="primaryContact.firstname"
          :user-id="primaryContact.id"
        />

        <span class="primary-contact-summary__badge" />
      </div>

      <div class="primary-contact-summary__info">
        <Typography
          v-if="partnershipDate"
          variant="body-small"
          color="gray-darker"
        >
          {{ transchoice('offer.contact.primary_contact.partnership', { date: partnershipDate.getFullYear() }) }}
        </Typography>

        <Typography
          variant="body-small"
          color="gray-darker"
        >
          {{ trans('offer.contact.primary_contact.response') }}
          {{ transchoice('global.response.time.minute', { count: averageResponseDelay }) }}
        </Typography>
      </div>
    </div>
  </div>
</template>
